import { render, staticRenderFns } from "./transferNc.vue?vue&type=template&id=31e081b2&scoped=true&"
import script from "./transferNc.vue?vue&type=script&lang=js&"
export * from "./transferNc.vue?vue&type=script&lang=js&"
import style0 from "./transferNc.vue?vue&type=style&index=0&id=31e081b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e081b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e081b2')) {
      api.createRecord('31e081b2', component.options)
    } else {
      api.reload('31e081b2', component.options)
    }
    module.hot.accept("./transferNc.vue?vue&type=template&id=31e081b2&scoped=true&", function () {
      api.rerender('31e081b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/transferNc.vue"
export default component.exports